import { createAction } from '../../../core/helpers'

import { FETCH_COURSE_TYPE } from '../action-types'

export const cleanupFetchCourseType = createAction(FETCH_COURSE_TYPE.CLEANUP)
